<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardBody>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.name')" type="text" placeholder="Ex: Juan Perez" v-model="driver.name"></CInput> 
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.username')" type="text" placeholder="Ex: username" v-model="driver.username"></CInput> 
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.personal_id')" type="text" placeholder="Ex: 0000000000" v-model="driver.personal_id"></CInput> 
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.license_id')" type="text" placeholder="Ex: username" v-model="driver.license_id"></CInput> 
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                disabled
                :label="$t('fields.payment_type')" 
                :value.sync="driver.payment_type"
                :plain="true"
                :options="payment_types"
                :placeholder="$t('fields.payment_type_placeholder')"
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.salary')" type="text" placeholder="Ex: 1000" v-model="driver.salary"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CSelect
                disabled
                :label="$t('fields.is_active')" 
                :value.sync="driver.status"
                :plain="true"
                :options="statuses"
                :placeholder="$t('fields.status_placeholder')"
              >
              </CSelect>
            </div>
          </div>
           <CButton color="primary" @click="editDriver()">
              {{ $t('button.edit') }}
          </CButton>
          <CButton color="primary" @click="goBack">{{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'Driver',
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
      driver: {
          name: '',
          social_id: '',
          username: '',
          password: '',
          password_confirmation: '',
          personal_id: '',
          payment_type: '',
          salary: '',
          status: 0
        },
        payment_types: [
          {
            label: 'Fixed',
            value: "fixed"
          },
          {
            label: 'Per Bottles',
            value: "bottles"
          }
        ],
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ]
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    driverId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getDriver();
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Drivers" });
    },
    getDriver() {
      // const token = this.token === null ? localStorage.getItem('api_token') : this.token;
      const token = localStorage.getItem('api_token');
      axios.get('/api/drivers/' + this.driverId + '?token=' + token)
      .then(response => {
        this.driver = response.data;
      }).catch(error => {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push({ path: '/login' });
        }
      });
    },
    editDriver() {
      this.$router.push({ name: 'EditDriver', params: { id: this.driverId } });
    },
  },
}


</script>
